import { BrowserRouter } from 'react-router-dom';
import AppRouter from './router';

/**
 * This same build is also served, unmodified, at root-level URLs like /octavia30lat for
 * campaigns that need to keep that short address in the address bar (see
 * public_html/octavia30lat/.htaccess — an internal `RewriteRule` with no [R] flag, so the
 * browser's URL never changes even though the response body is this app's index.html).
 * react-router's <BrowserRouter basename> only matches routes whose pathname actually starts
 * with it, so the basename has to be picked at runtime from the real URL rather than hardcoded
 * to /brandportal/newsletter — otherwise route matching would silently render a blank page for
 * anything reached via such an alias. Dropping the basename entirely for the alias case works
 * because router.tsx's routes are already generic /:slug patterns — the alias is only ever
 * reachable in the first place via that campaign's own stub .htaccess, gated server-side per
 * slug, so treating "not under /brandportal/newsletter" as "this app's own /:slug" is safe.
 */
function resolveBasename(): string {
  if (window.location.pathname.startsWith('/brandportal/newsletter')) {
    return process.env.PUBLIC_URL || '/brandportal/newsletter';
  }
  return '';
}

function App() {
  return (
    <BrowserRouter basename={resolveBasename()} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
